/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2016, 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../widgets/livewidget/nls/StringResources'
], function(StringResources) {

	'use strict';

	const PROCESSING = StringResources.get('processing');
	const NOT_AVAILABLE = StringResources.get('value_is_not_available');

	class  Summary {

		constructor(mappingInfo, isLocalSummary) {
			this._numberOfValues = 0;
			this._formatSpec = mappingInfo.formatSpec;
			this._aggregationType = mappingInfo.aggregationType;
			this._isLocalSummary = isLocalSummary;
			this._uniqueId = mappingInfo.id;
		}

		/**
		 * Add call back functions and required parameters when summary is local supported type
		 * @param {object} cbContext -
		 * categoryUIds: used as query Key to find the corresponding summary query result
		 * tupleUIds: used as tuple key to find the value from the right summary query result
		 * cbGetSummary: callback to invoke getSummary in SummaryFeature
		 * cbOnCellDataChange: callback when summary value is ready
		 */
		addCallBackContext(cbContext) {
			this.categoryUIds = cbContext.categoryUIds;
			this.tupleUIds = cbContext.tupleUIds;
			this.getSummary = cbContext.cbGetSummary;
			this.onCellDataChange = cbContext.cbOnCellDataChange;
			this.addSummaryValuePromise = cbContext.cbAddSummaryValuePromise;
		}

		addValue(value) {

			if (!this._isLocalSummary) {
				// Just return if local summary does not support the aggregation type
				return;
			}

			let newValue = value;
			if (value && typeof value === 'object') {
				newValue = value.getSummarizedValue();
			}

			if (typeof newValue !== 'number') {
				return;
			}

			if (typeof this.value !== 'number') {
				this.value = newValue;
				return;
			}

			switch (this._aggregationType) {
				case 'min':
					this.value = Math.min(this.value, newValue);
					break;

				case 'max':
					this.value = Math.max(this.value, newValue);
					break;

				default:
					this.value += newValue;
			}
		}

		getSummarizedValue(rowIdx, colIdx) {
			if (!this._isLocalSummary) {
				if (this.getSummary) {
					this.valuePromise = this.getSummary(this.categoryUIds, this._uniqueId, this.tupleUIds).then(value => {
						this.onCellDataChange(rowIdx, colIdx, value, this._formatSpec);
					});

					if (this.addSummaryValuePromise) {
						this.addSummaryValuePromise(this.valuePromise);
					}
					return PROCESSING;
				} else {
					return NOT_AVAILABLE;
				}
			}
			return this.getValue();
		}

		getValue() {
			return (typeof this.value === 'number') ? this.value : null;
		}

		getFormatSpec() {
			return this._formatSpec;
		}
	}

	return Summary;
});
